module.exports = __webpack_public_path__ + "img/not_sustainable_transport.985cb496.svg";